import React from 'react'

import { TbBold } from 'react-icons/tb'

import { useIntl } from '@app/intl/Intl'
import { MarkButton } from '@app/lib/inputs/RichEditor/marks/MarkButton'

export const MarkBoldButton = () => {
  const { formatMessage } = useIntl()

  return (
    <MarkButton
      format='Bold'
      icon={<TbBold />}
      aria-label={formatMessage({ id: 'RichEditor.Mark.Bold' })}
    />
  )
}
